"use strict";

require("./import-document.factory.js");

angular.module("vendor")
.controller("SectionImportDocumentList", function(
    $scope, $rootScope, $state, $stateParams, ImportDocument, FlashBag, gettextCatalog, IMPORT_LOG_TYPE, appConfig
) {
    var _this = this;

    $scope.filters = {}
    $scope.pagination = {};
    $scope.documentTypeLocalized = ImportDocument.getDocumentTypeLocalized();
    $scope.statusLocalized = ImportDocument.getStatusLocalized();
    $scope.importDocumentService = ImportDocument;
    $scope.API_URL = appConfig.API_SERVER;
    $scope.IMPORT_LOG_TYPE = IMPORT_LOG_TYPE;

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        $scope.documentTypeLocalized = ImportDocument.getDocumentTypeLocalized();
        $scope.statusLocalized = ImportDocument.getStatusLocalized();
        _this.search();
    });

    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
    });

    this.fetchDocumentTypeWithFilter = function(object_type) {
        $scope.filters["object_type"] = object_type;
        _this.search();
    };

    this.fetchStatusWithFilter = function(status) {
        $scope.filters["result_status"] = status;
        _this.search();
    };

    this.search = function() {
        var page = $scope.pagination.current_page;
        var search = $stateParams.search;

        ImportDocument.query(search, page, $scope.filters).$promise.then(function(data) {
            $scope.pagination = data.pagination;
            $scope.Documents = data.results;
        });
    };

    this.goToLog = function(document) {
        $state.go("importLogList", {document: document.id});
    };

    this.reProcessErrors = function(document) {
        ImportDocument.reProcessErrors(document.id).then(
            function onSuccess() {
                FlashBag.info(gettextCatalog.getString("The import will begin shortly. You'll receive an email when the process will be done."));
            }
        );
    };

    this.search();

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/import/import-document-list.controller.js
// module id = 1010
// module chunks = 0